import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import { Box } from "@mui/material";

const ui = {
  pageBg: "#f7f8fa",
  panel: "#ffffff",
  railBg: "#ffffff",
  border: "#e6e9ee",
  borderStrong: "#d9dee7",
  text: "#182230",
  muted: "#667085",
  subtle: "#98a2b3",
  soft: "#f8fafc",
  successBg: "#eefaf2",
  successBorder: "#b7e4c4",
  successText: "#17733b",
};

const LogoImage = ({ src, alt, maxWidth, maxHeight, placeholderSize }) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (!src || failed) {
    return (
      <Box
        sx={{
          width: Math.min(maxWidth, 36),
          height: Math.min(Math.max(maxHeight, 28), 36),
          display: "grid",
          placeItems: "center",
          color: ui.subtle,
        }}
      >
        <ImageOutlinedIcon sx={{ fontSize: placeholderSize }} />
      </Box>
    );
  }

  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      onError={() => setFailed(true)}
      sx={{
        maxWidth,
        maxHeight,
        width: "auto",
        height: "auto",
        objectFit: "contain",
        display: "block",
      }}
    />
  );
};

LogoImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string.isRequired,
  maxWidth: PropTypes.number,
  maxHeight: PropTypes.number,
  placeholderSize: PropTypes.number,
};

LogoImage.defaultProps = {
  src: "",
  maxWidth: 160,
  maxHeight: 30,
  placeholderSize: 16,
};

LogoImage.displayName = "LogoImage";

export default LogoImage;
